import React, { Component } from "react";
import WebCamUser from "../components/WebCamUser";
import CurrentUserDetails from "../components/CurrentUserDetails";
import Chat from "../components/Chat";
import NoLearners from "../components/NoLearners";
import PushUrlModal from "../components/PushUrlModal";
import ResumeRoomModal from "../components/ResumeRoomModal";
import AllPushUrlModal from "../components/AllPushUrlModal";
import { connect } from "react-redux";
import {
  addComment,
  updateNewMessage,
  clearComments,
  clearCommentsForUser,
  addChatBox,
  updateChatBoxes,
  clearChatBoxes,
  updateTyping,
  setActiveChat,
  setAssistanceRequest,
  setUserTyping,
  clearUnreadMessageCount,
} from "../reducers/chat";
import {
  updateExamName,
  updateExamCapacity,
  saveSession,
  saveEvent,
  updateEvents,
  updateCurrentExam,
  updateResumeRoomModal,
  updateSocketForUrlPush,
  updateAllPushModal,
  updatePushModal,
  updateZoomDesktop,
  updateZoomSRC,
  setMaximizedUser,
  updateMessage,
  updateShowMessage,
  updateFaceToFaceConnected,
} from "../reducers/session";
import { Card, Grid, Modal, Menu, Popup, Label, Message, Header, Segment, Icon, Form, Loader, Button } from "semantic-ui-react";
import { fetchDetailedExams } from "../reducers/exam";
import { getGlobalRoomView } from "../lib/roomService";
import { getEventsByRoom } from "../lib/sessionServices";
import ExpandedDesktop from "../components/ExpandedDesktop";
import socketUtil from "./../util/socket.js";
import * as Sentry from "@sentry/react";
import { playAudioNotification } from "./../lib/soundNotification";
import moment from "moment";
import { withTranslation } from "react-i18next";
import withRouter from "./../util/withRouter";

const mediasoup = require("mediasoup-client");

const MEDIA_TYPE_VIDEO = "video";
const MEDIA_TYPE_AUDIO = "audio";
const MEDIA_TYPE_DESKTOP = "desktop";

class ProctoringSession extends Component {
  constructor(props) {
    super(props);
    this.room_id = parseInt(this.props.params.room_id);
    this.onMaximize = this.onMaximize.bind(this);
    this.onZoom = this.onZoom.bind(this);
    this.exitZoom = this.exitZoom.bind(this);
    this.onBan = this.onBan.bind(this);
    this.onSoftBoot = this.onSoftBoot.bind(this);
    this.onMute = this.onMute.bind(this);
    this.onMoveToRoom = this.onMoveToRoom.bind(this);
    this.confirmMoveToRoom = this.confirmMoveToRoom.bind(this);
    this.closeMoveToRoomModal = this.closeMoveToRoomModal.bind(this);
    this.muteAll = this.muteAll.bind(this);
    this.muteAllChatNotifications = this.muteAllChatNotifications.bind(this);
    this.sendLinkToAll = this.sendLinkToAll.bind(this);
    this.updateExamCapacity = this.updateExamCapacity.bind(this);
    this.updateExamName = this.updateExamName.bind(this);
    this.urlModal = this.urlModal.bind(this);
    this.allUrlModal = this.allUrlModal.bind(this);
    this.pushUrl = this.pushUrl.bind(this);
    this.allPushUrl = this.allPushUrl.bind(this);
    this.handleLeaveExam = this.handleLeaveExam.bind(this);
    this.addUserToSession = this.addUserToSession.bind(this);
    this.getExamTitleById = this.getExamTitleById.bind(this);
    this.getExamTitle = this.getExamTitle.bind(this);
    this.startVideoCall = this.startVideoCall.bind(this);
    this.handleAssistanceRequest = this.handleAssistanceRequest.bind(this);
    this.handleUserTyping = this.handleUserTyping.bind(this);
    this.stopVideoCall = this.stopVideoCall.bind(this);
    this.updateMaxUserCycleTime = this.updateMaxUserCycleTime.bind(this);
    this.handleWindowBeforeUnload = this.handleWindowBeforeUnload.bind(this);
    this.handleProctorLeft = this.handleProctorLeft.bind(this);

    this.state = {
      consumerTransports: [],
      producerTransports: [],
      sessions: [],
      proctors: [],
      maximizedIndex: 0,
      maxCycleInterval: null,
      maxUserCycleTime: 0,
      monitorCount: 0,
      chatNotificationsMuted: false,
      moveModalOpen: false,
      moveTargetUser: null,
      moveTargetRoomId: "",
      availableActiveRooms: [],
      loadingActiveRooms: false,
      roomTitle: "",
    };
  }

  async startVideoCall(learner_id) {
    console.log("Starting video call for learner_id:", learner_id);
    if (this.state.producerTransports.length === 0) {
      await this._publish(MEDIA_TYPE_AUDIO, learner_id);
      await this._publish(MEDIA_TYPE_VIDEO, learner_id);

      this.props.socket.request("startFaceToFace", {
        user_id: this.props.kc.tokenParsed.sub,
        learner_id,
        room: this.room_id,
      });
    } else {
      this.props.socket.request("startFaceToFace", {
        user_id: this.props.kc.tokenParsed.sub,
        learner_id,
        room: this.room_id,
      });
    }
    this.props.updateFaceToFaceConnected(true);
    let sel = document.querySelector("#selected-user");
    if (sel) {
      sel.classList.add("incoming");
    } else {
      console.error("Selected user element not found for video call");
    }
  }

  async stopVideoCall(user_id) {
    console.log("Stopping video call for user_id:", user_id);
    this.props.socket.request("stopFaceToFace", {
      room: this.room_id,
      user_id,
    });
    this.props.updateMessage(
      this.props.t("ProctoringSession.faceToFaceDisconnected")
    );
    this.props.updateShowMessage(true);
    this.props.updateFaceToFaceConnected(false);
    let sel = document.querySelector("#selected-user");
    if (sel) {
      sel.classList.remove("incoming");
    } else {
      console.error("Selected user element not found for stop video call");
    }
  }

  async componentDidMount() {
    console.log("ProctoringSession componentDidMount called");
    window.addEventListener("beforeunload", this.handleWindowBeforeUnload);
    this.props.fetchDetailedExams();
    await this.props.clearChatBoxes();

    // Restore the event log from the DB so it survives a page reload.
    const events = await getEventsByRoom(this.room_id);
    console.log(events);
    if (events) {
      this.props.updateEvents(events);
    }

    if (!navigator.userActivation.hasBeenActive) {
      console.debug("User has not interacted with page, showing resume modal");
      this.props.updateResumeRoomModal(true);
    } else {
      console.debug("User has interacted, initializing proctoring session");
      await this.initializeProctoringSession();
    }
  }

  async initializeProctoringSession() {
    console.log("Initializing proctoring session");
    this.props.socket.request = socketUtil.promise(this.props.socket);
    this.props.socket.on("roomTitle", (roomTitle) => {
      this.setState({ roomTitle });
    });
    const data = await this.props.socket.request("getRouterRtpCapabilities", {
      room: this.room_id,
      user_id: this.props.kc.tokenParsed.sub,
      role: "proctor",
      username: this.props.kc.tokenParsed.preferred_username,
      first_name: this.props.kc.tokenParsed.given_name,
      last_name: this.props.kc.tokenParsed.family_name,
    });
    console.debug("Router RTP Capabilities received:", data);

    const currentProctor = {
      id: this.props.kc.tokenParsed.sub,
      username: this.props.kc.tokenParsed.preferred_username,
      name:
        `${this.props.kc.tokenParsed.given_name || ""} ${this.props.kc.tokenParsed.family_name || ""}`.trim() ||
        this.props.kc.tokenParsed.preferred_username,
    };
    this.setState({ proctors: [currentProctor] });

    this.props.socket.on("proctorJoined", (proctor) => {
      this.setState((prevState) => ({
        proctors: prevState.proctors.some((item) => item.id === proctor.id)
          ? prevState.proctors
          : [...prevState.proctors, proctor],
      }));
      playAudioNotification("Join.mp3");
    });

    this.props.socket.on("proctorLeft", (proctorId) => {
      this.setState((prevState) => ({
        proctors: prevState.proctors.filter((proctor) => proctor.id !== proctorId),
      }));
      playAudioNotification("Join.mp3");
    });

    this.props.socket.on("proctorPresence", (proctors) => {
      this.setState((prevState) => ({
        proctors: proctors.some((proctor) => proctor.id === currentProctor.id)
          ? proctors
          : [currentProctor, ...proctors],
      }));
    });

    const learners = await this.props.socket.request("joinExam", {
      role: "proctor",
      username: this.props.kc.tokenParsed.preferred_username,
      user_id: this.props.kc.tokenParsed.sub,
      room_id: this.room_id,
    });
    console.debug("Learners joined exam:", learners);

    await this._loadDevice(data);

    for (let learner of learners) {
      learner.webcamAudioStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_AUDIO
      );
      learner.webcamVideoStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_VIDEO
      );
      learner.desktopStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_DESKTOP
      );
      await this.addUserToSession(learner);
    }

    this.props.socket.on("userRequestedAssistance", (socket_id) => {
      this.handleAssistanceRequest(socket_id, true);
    });

    this.props.socket.on("usertyping", (data) => {
      this.handleUserTyping(data);
    });

    this.props.socket.on("userRejoined", async (learner) => {
      learner.webcamAudioStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_AUDIO
      );
      learner.webcamVideoStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_VIDEO
      );
      learner.desktopStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_DESKTOP
      );
      this.removeUserFromSession(learner.id);
      await this.addUserToSession(
        learner,
        `${learner.username} Rejoined Session`
      );
    });

    this.props.socket.on("userJoined", async (learner) => {

      if (learner.status !== "Checked In") {
         return;
      }

      this.props.clearCommentsForUser(learner.username);
      learner.webcamAudioStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_AUDIO
      );
      learner.webcamVideoStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_VIDEO
      );
      learner.desktopStream = await this._subscribe(
        learner.id,
        MEDIA_TYPE_DESKTOP
      );
  

      await this.addUserToSession(
        learner,
        `${learner.username} ${this.props.t("ProctoringSession.joinedSession")}`
      );
    });

    this.props.socket.on("userLeft", (data) => {
      const session = this.state.sessions.find(
        (session) => session.user_id === data.user_id
      );
      if (session) {
        // Create descriptive event message for intentional leave
        const reason = data.status || "left the exam";
        const event = `${session.username} - Left Exam (Intentional): ${reason}`;
        this.updateLog(event, session.id);

        const sessions = this.state.sessions.map((session) => {
          if (session.user_id === data.user_id) {
            return {
              ...session,
              render: false,
            };
          }
          return session;
        });
        this.setState({ sessions });
      }

      const chatBoxes = this.props.chatBoxes.filter(
        (chatBox) => chatBox.user_id !== data.user_id
      );
      this.props.updateChatBoxes(chatBoxes);

      //closing consumer transports for this user
      const consumerTransports = this.state.consumerTransports.find(
        (t) => t.user_id === data.user_id
      );
      if (consumerTransports) {
        for (let transport of consumerTransports.transports) {
          transport.close();
        }
      }

      this.removeUserFromSession(data.user_id);
    });
    this.props.socket.on("userDisconnected", (data) => {
      const session = this.state.sessions.find(
        (session) => session.user_id === data.user_id
      );
      if (session) {
        // Create descriptive event message for technical disconnect
        const reason = data.reason || "connection lost";
        const event = `${session.username} - Disconnected (Technical): ${reason}`;
        this.updateLog(event, session.id);
        const sessions = this.state.sessions.map((session) => {
          if (session.user_id === data.user_id) {
            return {
              ...session,
              disconnected: true,
            };
          }
          return session;
        });
        this.setState({ sessions });
      }

      const chatBoxes = this.props.chatBoxes.filter(
        (chatBox) => chatBox.user_id !== data.user_id
      );
      this.props.updateChatBoxes(chatBoxes);

      //closing consumer transports for this user
      const consumerTransports = this.state.consumerTransports.find(
        (t) => t.user_id === data.user_id
      );
      if (consumerTransports) {
        for (let transport of consumerTransports.transports) {
          transport.close();
        }
      }
    });

    this.props.socket.on("message", (msg) => {
      this.props.addComment({
        room: msg.room,
        text: msg.text,
        timestamp: moment.now(),
        author: `${msg.first_name} ${msg.last_name}`,
        user_id: msg.from,
      });
      this.props.updateNewMessage(true);
      
      // Play notification sound if chat notifications are not muted
      if (!this.state.chatNotificationsMuted) {
        playAudioNotification("ChatSound.mp3");
      }
    });

    this.props.socket.on("stopFaceToFace", () => {
      this.props.updateMessage(
        this.props.t("ProctoringSession.faceToFaceDisconnected")
      );
      this.props.updateShowMessage(true);
      this.props.updateFaceToFaceConnected(false);
      let sel = document.querySelector("#selected-user");
      sel.classList.remove("incoming");
    });

    this.props.socket.on("faceToFaceConnected", () => {
      this.props.updateMessage(
        this.props.t("ProctoringSession.faceToFaceConnected")
      );
      this.props.updateShowMessage(true);
      this.props.updateFaceToFaceConnected(true);
    });
    
    this.props.socket.on("runningApplicationsWarning", (data) => {
      const session = this.state.sessions.find(
        (session) => session.user_id === data.user_id
      );
      if (session) {
        const event = `${session.username} ${this.props.t(
          "ProctoringSession.runningApplicationsWarningMessage"
        )}: ${data.applications.join(", ")}`;
        this.updateLog(event, session.id);
      }
    });

    this.props.socket.on("userHasMultipleMonitorsWarning", (data) => {
      const session = this.state.sessions.find(
        (session) => session.user_id === data.user_id
      );
      if (session) {
        const event = `${session.username} ${this.props.t(
          "ProctoringSession.monitorWarningMessage"
        )}${data.monitorCount}`;
        this.updateLog(event, session.id);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.allExams !== this.props.allExams &&
      this.props.allExams &&
      this.props.allExams.length > 0
    ) {
      const updatedSessions = this.state.sessions.map((session) => {
        if (!session.exam_title) {
          const exam_title = this.getExamTitle(session);
          if (exam_title) {
            return { ...session, exam_title };
          }
        }
        return session;
      });
      this.setState({ sessions: updatedSessions });
    }

    if (prevState.maxUserCycleTime !== this.state.maxUserCycleTime) {
      clearInterval(this.state.maxCycleInterval);
      if (this.state.sessions.length > 1 && this.state.maxUserCycleTime != 0) {
        const maxCycleInterval = setInterval(() => {
          //if at the last index reset back to 0
          const maximizedIndex =
            this.state.maximizedIndex + 1 === this.state.sessions.length
              ? 0
              : this.state.maximizedIndex + 1;
          const learner = this.state.sessions[maximizedIndex];
          if (learner) {
            this.props.setMaximizedUser({
              username: learner.username,
              user_id: learner.user_id,
            });
            this.setState({ maximizedIndex });
          }
        }, this.state.maxUserCycleTime * 1000);

        this.setState({ maxCycleInterval });
      }
    }
  }

  handleAssistanceRequest(socket_id, requestedAssistance) {
    this.props.setAssistanceRequest({ socket_id, requestedAssistance });
  }

  handleUserTyping(data) {
    this.props.setUserTyping({
      socket_id: data.socket_id,
      typing: data.is_typing,
    });
  }

  getExamTitleById(examId) {
    // Look up exam title from Redux state
    if (!examId || !this.props.allExams) return "";
    const exam = this.props.allExams.find(
      (e) => String(e.id) === String(examId)
    );
    return exam ? exam.title : "";
  }

  getExamTitle(learner) {
    if (!learner) return "";
    if (learner.exam_title) return learner.exam_title;
    if (learner.exam_name) return learner.exam_name;
    if (learner.examination_title) return learner.examination_title;

    const examId =
      learner.exam_id ||
      learner.examId ||
      learner.examination_id ||
      learner.examinationId;

    return this.getExamTitleById(examId);
  }

  addUserToSession(learner, event = null) {
    return new Promise((resolve, reject) => {
      // Guard against duplicate "userJoined"-style events for the same user
      if (this.state.sessions.some((session) => session.user_id === learner.id)) {
        resolve();
        return;
      }
      if (this.state.sessions.length === 0) {
        this.props.setMaximizedUser({
          username: learner.username,
          user_id: learner.id,
        });
      }

      const exam_id =
        learner.exam_id ||
        learner.examId ||
        learner.examination_id ||
        learner.examinationId;

      const session = {
        ip: learner.ip,
        id: learner.socket_id,
        socket_id: learner.socket_id,
        username: learner.username,
        first_name: learner.first_name,
        last_name: learner.last_name,
        user_id: learner.id,
        selected: this.state.sessions.length === 0,
        booking_id: learner.booking_id,
        exam_id: exam_id,
        exam_title: this.getExamTitle(learner),
        webcamAudioStream: learner.webcamAudioStream,
        webcamVideoStream: learner.webcamVideoStream,
        desktopStream: learner.desktopStream,
        disconnected: false,
        joinedExamCount: learner.joinedExamCount,
        render: true,
        muted: true,
      };

      this.setState({
        sessions: [...this.state.sessions, session],
      });

      const comments = learner.messages.map((message) => {
        return {
          room: message.room,
          text: message.text,
          timestamp: message.timestamp,
          author: `${message.first_name} ${message.last_name}`,
          user_id: learner.id,
        };
      });

      this.props.addChatBox({
        socket_id: learner.socket_id,
        username: learner.username,
        first_name: learner.first_name,
        last_name: learner.last_name,
        user_id: learner.id,
        assistance_requested: false,
        unreadMessages: learner.messages.length,
        comments,
      });

      this.updateLog(event, session.id);

      resolve();
    });
  }

  removeUserFromSession(user_id) {
    const sessions = this.state.sessions.filter(
      (data) => data.user_id !== user_id
    );
    this.setState({ sessions });
  }

  onMaximize(maximizedIndex) {
    const learner = this.state.sessions[maximizedIndex];
    this.props.setMaximizedUser({
      username: learner.username,
      user_id: learner.user_id,
    });
    // Turn off auto-cycling when user manually maximizes
    this.setState({ maximizedIndex, maxUserCycleTime: 0 });
  }

  onZoom(user_id, mediaType = "desktop") {
    let session = this.state.sessions.filter((session) => {
      return session.user_id === user_id;
    });
    if (session[0]) {
      const media =
        mediaType === "webcam"
          ? session[0].webcamVideoStream
          : session[0].desktopStream;
      this.props.updateZoomSRC(media);
      this.props.updateZoomDesktop();
    }
  }

  exitZoom() {
    this.props.updateZoomSRC(null);
    this.props.updateZoomDesktop();
  }

  onBan(user_id, username) {
    let session = this.state.sessions.find(
      (session) => session.user_id === user_id
    );
    if (!session) {
      console.error(`Session not found for user ${user_id}`);
      return;
    }
    let event = username + ` ${this.props.t("general.banned")}`;
    this.updateLog(event, session.id);

    this.props.socket.emit("userBanned", {
      socket_id: session.id,
      user_id: session.user_id,
      room: this.room_id,
    });

    this.removeUserFromSession(user_id);
  }
  onSoftBoot(user_id, username) {
    let session = this.state.sessions.find(
      (session) => session.user_id === user_id
    );
    
    if (!session) {
      console.error(`Session not found for user ${user_id}`);
      return;
    }
    
    let event = username + ` ${this.props.t("general.softBooted")}`;
    this.updateLog(event, session.id);

    this.props.socket.emit("userSoftBooted", {
      socket_id: session.socket_id,
      user_id: session.user_id,
      room: this.room_id,
    });

    this.props.updateMessage(`${username} has been soft booted from the session.`);
    this.props.updateShowMessage(true);

    this.removeUserFromSession(user_id);
  }

  onMute(user_id) {
    let audio = document.getElementById(user_id + "_audio");
    if (audio) {
      audio.muted = !audio.muted;
    }
    const sessions = this.state.sessions.map((session) => {
      if (session.user_id === user_id) {
        return {
          ...session,
          muted: !session.muted,
        };
      }
      return session;
    });
    this.setState({ sessions });
  }

  muteAll() {
    const shouldMute = !this.state.sessions.every((session) => session.muted);
    const nextSessions = this.state.sessions.map((session) => {
      const audio = document.getElementById(session.user_id + "_audio");
      if (audio) {
        audio.muted = shouldMute;
      }
      return {
        ...session,
        muted: shouldMute,
      };
    });

    this.setState({ sessions: nextSessions });
  }

  muteAllChatNotifications() {
    this.setState((prevState) => ({
      chatNotificationsMuted: !prevState.chatNotificationsMuted,
    }));
  }

  sendLinkToAll() {
    this.allUrlModal();
  }

  async onMoveToRoom(user_id, username) {
    this.setState({
      moveModalOpen: true,
      moveTargetUser: { user_id, username },
      moveTargetRoomId: "",
      loadingActiveRooms: true,
      availableActiveRooms: [],
    });

    const rooms = await getGlobalRoomView();
    const otherActiveRooms = (rooms || []).filter(
      (room) => String(room.room_id) !== String(this.room_id)
    );

    this.setState({
      availableActiveRooms: otherActiveRooms,
      loadingActiveRooms: false,
    });
  }

  closeMoveToRoomModal() {
    this.setState({
      moveModalOpen: false,
      moveTargetUser: null,
      moveTargetRoomId: "",
      availableActiveRooms: [],
    });
  }

  confirmMoveToRoom() {
    const { moveTargetUser, moveTargetRoomId, availableActiveRooms } =
      this.state;
    if (!moveTargetUser || !moveTargetRoomId) {
      return;
    }

    const targetRoom = availableActiveRooms.find(
      (room) => String(room.room_id) === String(moveTargetRoomId)
    );

    const payload = {
      user_id: moveTargetUser.user_id,
      roomId: moveTargetRoomId,
      roomTitle: targetRoom ? targetRoom.room_title : undefined,
    };
    // Server relays this to the learner's client to move rooms
    this.props.socket.emit("changeRoom", payload);

    this.closeMoveToRoomModal();
  }

  updateLog(event, session_id) {
    if (event) {
      let tmpEvent = {
        session_id,
        timestamp: moment.now(),
        event: JSON.stringify(event),
        proctor_id: this.props.kc.tokenParsed.sub,
      };
      this.props.saveEvent(tmpEvent);
    }
  }

  async _loadDevice(routerRtpCapabilities) {
    try {
      this.device = new mediasoup.Device();
      await this.device.load({ routerRtpCapabilities });
    } catch (e) {
      Sentry.captureException(e);
    }
  }
  /**
     * Publish audio/video for proctor face to face call
     * @param {String} mediaType
     * @param {String} learner_id
     */
  async _publish(mediaType, learner_id) {
    try {
      const data = await this.props.socket.request("createProducerTransport", {
        forceTcp: false,
        rtpCapabilities: this.device.rtpCapabilities,
        role: "proctor",
        kind: mediaType,
        user_id: this.props.kc.tokenParsed.sub,
        room: this.room_id,
      });

      const transport = this.device.createSendTransport(data);
      this.setState({
        producerTransports: this.state.producerTransports.concat(transport),
      });
      transport.on("connect", async ({ dtlsParameters }, callback, errback) => {
        this.props.socket
          .request("connectProducerTransport", {
            dtlsParameters,
            kind: mediaType,
            room: this.room_id,
            user_id: this.props.kc.tokenParsed.sub,
          })
          .then(callback)
          .catch(errback);
      });

      transport.on(
        "produce",
        async ({ kind, rtpParameters }, callback, errback) => {
          try {
            const { id } = await this.props.socket.request("produce", {
              transportId: transport.id,
              kind,
              rtpParameters,
              room: this.room_id,
              role: "proctor",
              username: this.props.username,
              user_id: this.props.kc.tokenParsed.sub,
              type: mediaType,
              learner_id,
            });
            callback({ id });
          } catch (e) {
            Sentry.captureException(e);
            errback(e);
          }
        }
      );

      transport.on("connectionstatechange", (state) => {
        switch (state) {
          case "failed":
            transport.close();
            throw new Error(`FAILED TO PRODUCE ${mediaType}`);
          default:
            break;
        }
      });

      this.localStream = await this._getUserMedia(transport, mediaType);
    } catch (e) {
      Sentry.captureException(e);
    }
  }

  /**
   *
   * @param {*} transport
   * @param {*} kind
   */
  async _getUserMedia(transport, kind) {
    try {
      if (!this.device.canProduce(kind)) {
        throw new Error("error: cannot produce video");
      }
      const stream = await navigator.mediaDevices.getUserMedia({
        video: kind === MEDIA_TYPE_VIDEO,
        audio: kind === MEDIA_TYPE_AUDIO,
      });
      const track =
        kind === MEDIA_TYPE_VIDEO
          ? stream.getVideoTracks()[0]
          : stream.getAudioTracks()[0];
      const params = { track };
      await transport.produce(params);
      return stream;
    } catch (e) {
      Sentry.captureException(e);
    }
  }

  /**
   * Start the process of consuming a learners webcam/audio/desktop
   * @param {String} learner_id
   * @param {String} type
   */
  async _subscribe(user_id, type) {
    try {
      const data = await this.props.socket.request("createConsumerTransport", {
        forceTcp: false,
        kind: type,
        room: this.room_id,
        consuming_id: user_id,
        user_id: this.props.kc.tokenParsed.sub,
        role: "proctor",
      });
      
      const transport = this.device.createRecvTransport(data);

      //grab existing consumerTransports for this user
      const existingTransports = this.state.consumerTransports.find(
        (t) => t.user_id === user_id
      );
      const consumerTransports = existingTransports
        ? existingTransports.transports
        : [];

      //add new transport to state so it can be closed later
      this.setState({
        consumerTransports: [
          ...this.state.consumerTransports,
          { user_id, transports: [...consumerTransports, transport] },
        ],
      });

      transport.on("connect", ({ dtlsParameters }, callback, errback) => {
        this.props.socket
          .request("connectConsumerTransport", {
            transportId: transport.id,
            dtlsParameters,
            room: this.room_id,
            kind: type,
            user_id: this.props.kc.tokenParsed.sub,
            consuming_id: user_id,
          })
          .then(callback)
          .catch(errback);
      });

      transport.on("connectionstatechange", (state) => {
        switch (state) {
          case "failed":
            transport.close();
            throw new Error(`FAILED TO CONSUME ${type}`);
          default:
            break;
        }
      });

      return await this._consume(transport, user_id, type);
    } catch (e) {
      Sentry.captureException(e);
    }
  }

  /**
   * Consume either a learners audio/webcam/desktop
   * @param {Object} transport
   * @param {String} learner_id
   * @param {String} type
   */
  async _consume(transport, learner_id, type) {
    const { rtpCapabilities } = this.device;
    const data = await this.props.socket.request("consume", {
      rtpCapabilities,
      room: this.room_id,
      kind: type,
      consuming_id: learner_id,
      consumer_id: this.props.kc.tokenParsed.sub,
    });

    const { producerId, id, kind, rtpParameters } = data;

    const codecOptions = {};

    const consumer = await transport.consume({
      id,
      producerId,
      kind,
      rtpParameters,
      codecOptions,
    });

    const stream = new MediaStream();
    stream.addTrack(consumer.track);
    return stream;
  }

  updateExamName(e) {
    this.props.updateExamName(e.target.value);
  }
  updateExamCapacity(e) {
    this.props.updateExamCapacity(e.target.value);
  }

  urlModal(socket_id) {
    this.props.updateSocketForUrlPush(socket_id);
    this.props.updatePushModal();
  }
  allUrlModal() {
    this.props.updateAllPushModal();
  }
  allPushUrl() {
    if (this.props.url !== "") {
      let socket_all = "all";
      this.props.socket.emit("testUrl", {
        socket_id: socket_all,
        url: this.props.url,
        room: this.room_id,
      });
      this.props.updateAllPushModal();
    }
  }
  pushUrl() {
    if (this.props.url !== "") {
      this.props.socket.emit("testUrl", {
        socket_id: this.props.socketForUrlPush,
        url: this.props.url,
      });
      this.props.updatePushModal();
    }
  }

  handleLeaveExam() {
    this.props.socket.emit("proctorLeftExam");
    this.setState({ sessions: [] });
    this.props.updateEvents([]);
    this.props.updateCurrentExam(null);
    this.props.clearComments();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
    this.handleProctorLeft();
  }
  updateMaxUserCycleTime(e) {
    this.setState({ maxUserCycleTime: e.target.value });
  }
  handleWindowBeforeUnload() {
    this.handleProctorLeft();
  }
  handleProctorLeft() {
    this.props.socket.off("userRequestedAssistance");
    this.props.socket.off("usertyping");
    this.props.socket.off("userSharedStreams");
    this.props.socket.off("message");
    this.props.socket.off("proctorJoined");
    this.props.socket.off("proctorLeft");
    this.props.socket.off("proctorPresence");
    this.props.socket.off("roomTitle");
    this.props.socket.off("userJoined");
    this.props.socket.off("userLeft");
    this.props.socket.off("webcamIceCandidate");
    this.props.socket.off("webcamViewerResponse");
    this.props.socket.off("desktopIceCandidate");
    this.props.socket.off("desktopViewerResponse");
    this.props.socket.off("listOfCurrentLearners");
    this.props.socket.off("stopFaceToFace");
    this.props.socket.off("faceToFaceConnected");
    this.props.socket.off("userDisconnected");
    this.props.socket.off("userRejoined");
    this.props.socket.off("runningApplicationsWarning");
    this.props.socket.off("userHasMultipleMonitorsWarning");

    //closing consumer and producer transports
    for (let consumerTransport of this.state.consumerTransports) {
      for (let transport of consumerTransport.transports) {
        transport.close();
      }
    }

    for (let transport of this.state.producerTransports) {
      transport.close();
    }

    this.handleLeaveExam();
  }
  render() {
    if (this.state.sessions.length > 0) {
      const maximizedUserId =
        this.props.maximizedUser && this.props.maximizedUser.user_id;
      const selectedSession = this.state.sessions.find(
        (s) => s.user_id === maximizedUserId && s.render
      );
      const unselectedSessions = this.state.sessions.filter(
        (s) => s.user_id !== maximizedUserId && s.render
      );

      return (
        <div
          style={{
            height: "calc(100vh - 120px)",
            boxSizing: "border-box",
            paddingTop: 0,
            paddingLeft: 8,
            paddingRight: 8,
            paddingBottom: 64,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <ResumeRoomModal
            initializeProctoringSession={() =>
              this.initializeProctoringSession()
            }
          />
          <PushUrlModal pushUrl={this.pushUrl} />
          <AllPushUrlModal allPushUrl={this.allPushUrl} />
          <Modal
            open={this.state.moveModalOpen}
            onClose={this.closeMoveToRoomModal}
            size="tiny"
          >
            <Modal.Header>
              {this.state.moveTargetUser
                ? `Move ${this.state.moveTargetUser.username} to Another Room`
                : "Move Student to Another Room"}
            </Modal.Header>
            <Modal.Content>
              {this.state.loadingActiveRooms ? (
                <Loader active inline="centered">
                  Loading active rooms...
                </Loader>
              ) : this.state.availableActiveRooms.length === 0 ? (
                <p>No other active rooms are currently available.</p>
              ) : (
                <Form>
                  <Form.Field>
                    <label>Select a Room</label>
                    <select
                      value={this.state.moveTargetRoomId}
                      onChange={(e) =>
                        this.setState({ moveTargetRoomId: e.target.value })
                      }
                    >
                      <option value=""></option>
                      {this.state.availableActiveRooms.map((room) => (
                        <option key={room.room_id} value={room.room_id}>
                          {room.room_title} ({room.student_count} student
                          {room.student_count === 1 ? "" : "s"})
                        </option>
                      ))}
                    </select>
                  </Form.Field>
                </Form>
              )}
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={this.closeMoveToRoomModal}>Cancel</Button>
              <Button
                primary
                disabled={!this.state.moveTargetRoomId}
                onClick={this.confirmMoveToRoom}
              >
                Confirm Move
              </Button>
            </Modal.Actions>
          </Modal>
          <Grid stackable style={{ flex: 1, minHeight: 0, margin: 0, width: "100%" }}>
            <Grid.Row style={{ height: "100%", alignItems: "stretch" }}>
              {/* LEFT SECTION: Unselected students list */}
              <Grid.Column width={6} style={{ paddingRight: "8px", minHeight: 0, display: "flex", flexDirection: "column" }}>
                <Header as="h4" attached="top" style={{ background: "#f8f9fa", margin: 0 }}>
                  Students ({unselectedSessions.length})
                </Header>
                <Segment attached style={{ flex: 1, minHeight: 0, maxHeight: "calc(100vh - 264px)", overflowY: "auto", overflowX: "hidden", padding: "8px", display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "8px", alignContent: "start" }}>
                  {unselectedSessions.length > 0 ? (
                    unselectedSessions.map((data) => {
                      const index = this.state.sessions.findIndex((s) => s.user_id === data.user_id);
                      return (
                        <div key={`${data.user_id}_unselected_card`}>
                          <WebCamUser
                            id={data.id}
                            disconnected={data.disconnected}
                            socketId={data.socket_id}
                            {...data}
                            exam_title={data.exam_title || this.getExamTitle(data)}
                            onMaximize={this.onMaximize}
                            onZoom={this.onZoom}
                            onBan={this.onBan}
                            onMoveToRoom={this.onMoveToRoom}
                            urlModal={this.urlModal}
                            user={data.username}
                            webcamVideoStream={data.webcamVideoStream}
                            webcamAudioStream={data.webcamAudioStream}
                            desktopStream={data.desktopStream}
                            allUrlModal={this.allUrlModal}
                            onSoftBoot={this.onSoftBoot}
                            startVideoCall={this.startVideoCall}
                            stopVideoCall={this.stopVideoCall}
                            user_id={data.user_id}
                            index={index}
                            onMute={this.onMute}
                            muted={data.muted}
                          />
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ textAlign: "center", color: "#888", padding: "20px 0" }}>
                      No unselected students
                    </div>
                  )}
                </Segment>
              </Grid.Column>

              {/* MIDDLE SECTION: Selected student full view */}
              <Grid.Column width={6} style={{ paddingLeft: "8px", paddingRight: "8px", minHeight: 0, overflow: "hidden" }}>
                {selectedSession ? (
                  <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
                    <WebCamUser
                      id={selectedSession.id}
                      disconnected={selectedSession.disconnected}
                      socketId={selectedSession.socket_id}
                      {...selectedSession}
                      exam_title={selectedSession.exam_title || this.getExamTitle(selectedSession)}
                      onMaximize={this.onMaximize}
                      onZoom={this.onZoom}
                      onBan={this.onBan}
                      onMoveToRoom={this.onMoveToRoom}
                      urlModal={this.urlModal}
                      user={selectedSession.username}
                      webcamVideoStream={selectedSession.webcamVideoStream}
                      webcamAudioStream={selectedSession.webcamAudioStream}
                      desktopStream={selectedSession.desktopStream}
                      allUrlModal={this.allUrlModal}
                      onSoftBoot={this.onSoftBoot}
                      startVideoCall={this.startVideoCall}
                      stopVideoCall={this.stopVideoCall}
                      user_id={selectedSession.user_id}
                      index={this.state.sessions.findIndex((s) => s.user_id === selectedSession.user_id)}
                      onMute={this.onMute}
                      muted={selectedSession.muted}
                    />
                  </div>
                ) : (
                  <Segment placeholder style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Header icon style={{ color: "#666" }}>
                      <Icon name="user cursor" />
                      Select a student from the left panel to maximize view
                    </Header>
                  </Segment>
                )}
                <Modal
                  size="fullscreen"
                  open={this.props.zoomDesktop}
                  onClose={this.exitZoom}
                >
                  <Modal.Header>
                    {this.props.t("ProctoringSession.expandView")}
                  </Modal.Header>
                  <Modal.Content
                    style={{
                      height: "calc(100vh - 100px)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                  >
                    <ExpandedDesktop
                      media={this.props.zoomedSRC}
                      style={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        background: "#000",
                      }}
                    />
                  </Modal.Content>
                </Modal>
              </Grid.Column>

              {/* RIGHT SECTION: Right sided menu */}
              <Grid.Column width={4} style={{ paddingLeft: "8px", minHeight: 0, overflow: "hidden" }}>
                <div
                  style={{
                    width: "100%",
                    minWidth: "260px",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div style={{ flex: 1, minHeight: 0 }}>
                    <CurrentUserDetails
                      roomTitle={
                        this.state.roomTitle ||
                        this.props.currentExam ||
                        `Room ${this.room_id}`
                      }
                      session={selectedSession}
                      proctors={this.state.proctors}
                      onMuteAll={this.muteAll}
                      allMuted={
                        this.state.sessions.length > 0 &&
                        this.state.sessions.every((session) => session.muted)
                      }
                      onMuteAllChatNotifications={this.muteAllChatNotifications}
                      onSendLinkToAll={this.sendLinkToAll}
                      chatNotificationsMuted={this.state.chatNotificationsMuted}
                      updateMaxUserCycleTime={this.updateMaxUserCycleTime}
                      maxUserCycleTime={this.state.maxUserCycleTime}
                      cycleDisabled={this.state.sessions.length === 1}
                    />
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <div className="chatBar">
                  <Menu floated="right" inverted>
                    {this.props.chatBoxes.map((data, i) => {
                      return (
                        <Popup
                          onClose={() => this.props.setActiveChat(null)}
                          key={`${data.user_id}_chat_box`}
                          content={
                            <Chat
                              socket={this.props.socket}
                              socket_id={data.socket_id}
                              room_id={this.room_id}
                              user_id={data.user_id}
                              username={data.username}
                              firstName={data.first_name}
                              lastName={data.last_name}
                              comments={data.comments}
                            />
                          }
                          position="top left"
                          on="click"
                          trigger={
                            <Menu.Item
                              color={
                                data.assistance_requested
                                  ? "red"
                                  : data.typing
                                    ? "green"
                                    : "black"
                              }
                              active={
                                data.assistance_requested
                                  ? data.assistance_requested
                                  : data.typing
                                    ? data.typing
                                    : false
                              }
                              onClick={() => {
                                this.handleAssistanceRequest(
                                  data.socket_id,
                                  false
                                );
                                this.props.setActiveChat(data.user_id);
                                this.props.clearUnreadMessageCount(
                                  data.socket_id
                                );
                              }}
                            >
                              {`${data.first_name} ${data.last_name} (${data.username})`}
                              {data.typing ? (
                                <div className="dots-container">
                                  <div className="dot-elastic"></div>
                                </div>
                              ) : null}
                              {data.unreadMessages > 0 ? (
                                <Label color="teal">
                                  {data.unreadMessages}
                                </Label>
                              ) : null}
                            </Menu.Item>
                          }
                        />
                      );
                    })}
                  </Menu>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      );
    } else {
      return (
        <div style={{ margin: 8 }}>
          <ResumeRoomModal
            initializeProctoringSession={() =>
              this.initializeProctoringSession()
            }
          />
          <NoLearners />
        </div>
      );
    }
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      kc: state.keycloak,
      maximizedUser: state.session.maximizedUser,
      activeChat: state.chat.activeChat,
      url: state.session.url,
      socketForUrlPush: state.session.socketForUrlPush,
      zoomDesktop: state.session.zoomDesktop,
      zoomedSRC: state.session.zoomedSRC,
      currentExam: state.session.currentExam,
      chatBoxes: state.chat.chatBoxes,
      resumeAll: state.session.showResumeRoomModal, //torerender
      allExams: state.exam.allExams,
    }),
    {
      updateExamCapacity,
      saveEvent,
      updateEvents,
      fetchDetailedExams,
      updateExamName,
      updateCurrentExam,
      saveSession,
      setActiveChat,
      setAssistanceRequest,
      setUserTyping,
      updateSocketForUrlPush,
      clearCommentsForUser,
      updatePushModal,
      updateResumeRoomModal,
      updateZoomDesktop,
      updateZoomSRC,
      setMaximizedUser,
      addComment,
      updateNewMessage,
      clearComments,
      updateAllPushModal,
      updateMessage,
      updateShowMessage,
      updateFaceToFaceConnected,
      addChatBox,
      updateChatBoxes,
      clearChatBoxes,
      updateTyping,
      clearUnreadMessageCount,
    }
  )(withRouter(ProctoringSession))
);
